

<template>
	<div>
		<vFormItem :label="$t('fbb.warehouse.user_customer', { defaultValue: '可使用的客户' })" label-width="150" v-if="type!=='query'">
			<vTransfer
				style="height:360px;"
				:data="datalist"
				identifier="value"
				:target-keys="targetKeys"
				:list-style="listStyle"
				:render-format="renderFormat"
                :filter-method="filterMethod"
				filterable
				@on-transfer="handleChange"
			></vTransfer>
		</vFormItem>
		<TableList v-else v-bind="getTableProps"></TableList>
	</div>
</template>

<script>
import TableList from "@components/templates/tablelist";
import { HttpManageWareCustomeList } from '@/service/basicdata';
import { HttpSysList, HttpNowManageOrgList, HttpNextOrgSelfList } from '@mods/service/dictionary';
import { mapGetters } from 'vuex';
export default {
	props: ['data', 'status', 'querytype', 'activeids'],
	components: {
		TableList
	},
	data() {
		return {
			type: this.$route.params.type || this.querytype,
			id: this.$route.query.id || this.activeids,
			targetKeys: [],
			listStyle: {
				width: '30%',
				minWidth: '260px'
            },
            datalist: [],
            initDataList: [],
		}
	},
	watch: {
		data:{
			immediate:true,
			handler(val){
				this.targetKeys = (val || []).filter(item=>item.active == 1).map(item => item.orgId);
                this.initDataList = (val || []).map(item => item.orgId);
			}
        },
        status:{
			immediate: false,
            handler(newVal, oldVal){
                if(this.type == 'edit' && newVal == 'YES' && oldVal == 'NO'){
                    this.targetKeys = this.initDataList;
                }
            }
        },
    },
    created(){
        this.getOrgList()
    },
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList']),
		getTableProps() {
			return {
				ajaxRequest: HttpManageWareCustomeList,
				startUp: 1,
				initFormData:{
					id:this.id,
				},
				columns: [{
					title: this.$t('fbb.warehouse.sequence', { defaultValue: '序号' }),
					type: 'index',
					width: 100,
				}, {
					title: this.$t('fbb.alloment.client_organization', { defaultValue: '客户名称' }),
					key: 'organizationId',
					render: (h,{row})=>this.findRenderLabel(this.datalist, row.key)
				}]
			}
		},
		// getTargetData() {
		// 	return this.targetKeys.map(key => {
		// 		const data = this.getBillcusorgList.find(item => item.value == key);
		// 		return {
		// 			"orgId": data.value,
		// 			"orgCode": data.attach.code,
		// 		}
		// 	})
		// }
	},
	methods: {
		renderFormat(item) {
			return item.description ? `${item.label}-${item.description}` : item.label;
		},
		handleChange(targetKeys, direction, moveKeys) {
			console.log(targetKeys)
			this.targetKeys = targetKeys;
        },
        getOrgList(){
            // let array1 = [],array2 = [];
            // HttpSysList().then(res=>{
            //     array1 = res.data || []
            //     HttpNowManageOrgList().then(res=>{
            //         array2 = res.data.accessResourceIds || []
            //         array1.map(item=>{
            //         array2.map(json=>{

            //             if(item.id === json){
            //                 let jsondata = {
            //                     label:item.name,
            //                     value:item.id
            //                 }
            //                 this.datalist.push(jsondata)
            //             }
            //         })
            //     })
            //     })
            // })
            HttpNextOrgSelfList().then(res => {
                this.datalist = res.data.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
            }, err => {
                this.$VMessage.error(err.message);
            })
            // console.log(this.datalist)
        },
        // 添加自定义搜索函数,不区分大小写
        filterMethod (data, query) {
            return data.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        },
	}
}
</script>
